import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { RiDashboardHorizontalFill } from "react-icons/ri";
import "bootstrap/dist/css/bootstrap.min.css";
import { GrTasks } from "react-icons/gr";
import { VscDebugAlt } from "react-icons/vsc";
import { GoProjectSymlink } from "react-icons/go";
import { FaBars, FaBug, FaUser } from "react-icons/fa";
import { TbFileReport } from "react-icons/tb";
import nt from "../assets/images/nt.png";
import "./HomeLayout.css";
import { useAuth } from "../ProtectedRoute/AppContext";
import logo from '../assets/images/logo.png'; 

function HomeLayout() {
  
  const { user } = useAuth();
  return (
    <div className="home-container d-flex flex-column vh-100">
      {/* Top Navbar */}
      <nav className="navbar navbar-expand-lg p-1 bg-primary">
        <div className="container-fluid d-flex align-items-center">
          {/* Navbar Brand */}
          <div className="navbar-brand d-flex align-items-center">
           
            <h3 className="text-white ms-2 mb-0"><img src={logo} width={200} className="h-8" alt="..." /></h3>
          </div>

          {/* Toggle Button for Mobile */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <FaBars size={24} className="text-white" />
          </button>

          {/* Right Section: Notifications & User Icon */}
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <div className="ms-auto d-flex align-items-center">
           

              {/* User Icon */}
              <NavLink to="/user" className="btn btn-icon">
              <span className="text-white">{user.userName||"User"}</span>
                <FaUser size={20} className=" ms-2 text-white" />
              </NavLink>
            </div>
          </div>
        </div>
      </nav>

      {/* Sidebar and Main Content */}
      <div className="d-flex flex-grow-1">
        {/* Sidebar */}
        <div className="sidebar col bg-primary d-flex flex-column align-items-center py-4 min-vh-50">
          <NavLink to="/" className="nav-link my-1 text-white text-center">
            <RiDashboardHorizontalFill size={24} />
            <span className="d-block">Dashboard</span>
          </NavLink>
          {user && (user.role === 1 || user.role === 2)&&(
          <NavLink
            to="/reports"
            className="nav-link my-1 text-white text-center"
          >
            <TbFileReport size={24} />
            <span className="d-block">Reports</span>
          </NavLink>)}
          <NavLink
            to="/projects"
            className="nav-link my-1 text-white text-center"
          >
            <GoProjectSymlink size={24} />
            <span className="d-block">Projects</span>
          </NavLink>
          <NavLink to="/tasks" className="nav-link my-1 text-white text-center">
            <GrTasks size={24} />
            <span className="d-block">Tasks</span>
          </NavLink>
          <NavLink to="/bugs" className="nav-link my-1 text-white text-center">
            <VscDebugAlt size={24} />
            <span className="d-block">Bugs</span>
          </NavLink>
        </div>

        {/* Main Content */}
        <div className="main-content col-md-11 flex-grow-1 p-4 bg-light">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default HomeLayout;
